export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";